import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import ReactPlayer from "react-player";



function Mbdhar() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray"/>
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">MB DHAR & SON JEWELLERS</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 style={{ color: "#736f6fff" }} className='misaa'> MB Dhar and Son Jewellers – A Legacy of Trust and Excellence <b>Since 1925</b>
                                </h1>
                                <p><a href='https://www.mbdharandsonjewellers.com/' target="_blank" rel="noopener noreferrer">https://www.mbdharandsonjewellers.com/</a></p>
                                <p>When it comes to jewellery in Berhampore, Murshidabad, one name stands out with pride – MB Dhar and Son Jewellers. Established in 1925, this iconic showroom has been serving customers with exquisite jewellery designs, exceptional craftsmanship, and unmatched trust for almost a century.</p>
                                <h3>My Journey with MB Dhar and Son Jewellers</h3>
                                <p className='websitedevelopment mb-2' style={{ color: "grey" }}>I have been associated with MB Dhar and Son Jewellers for over two years, and it has been an incredibly fulfilling experience. The owner, Hon’ble Rajib Dhar, is known for his warm and respectful nature. His entire family treats everyone with kindness, making every interaction truly memorable.</p>


                             
                            </div>
                            <div className="col-md-5">
                                                                    <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=wTeKfooBC7M" />
                                    
                                                                        
                            
                            </div>
                               <p className='websitedevelopment mt-2' style={{ color: "grey" }}><small>Two years ago, I had the privilege to develop their official website – www.mbdharandsonjewellers.com – and I have been providing ongoing service and support ever since. Alongside website maintenance, I am also handling their online marketing to help the brand reach a wider audience.</small></p>
                                 <p className='websitedevelopment' style={{ color: "grey" }}><small>Located at 27, Daihatta Road (Sonapatti), Khagra – 742103, Dist. Murshidabad, the showroom is more than just a place to buy jewellery – it is a place where customers are treated like family. I have personally visited the showroom many times and have always received the highest respect from everyone there.</small></p>
                                 <p>One of the most cherished events is their Annual Programme in January, where the atmosphere is filled with joy, laughter, and togetherness. I have attended twice, and each time it felt like being part of a grand family celebration.</p>
                        </div>
                        <br />
                        <h3>Recognition and Appreciation</h3>
                        <h6 className='websitedevelopment mb-2' style={{ color: "grey" }}>Hon’ble Rajib Babu has been kind enough to give me an excellent review for my work, which is a matter of great pride for me. Such appreciation motivates me to keep delivering my best and to strengthen this beautiful professional bond.</h6>

      
                        <br />
                        <h3 className='mb-3'><b>Why MB Dhar and Son Jewellers is the Best in Berhampore</b></h3>
                        <p className='mb-2'><b>Established Legacy –</b> Serving customers since 1925</p>
                        <p className='mb-2'>
                            <b>Premium Jewellery Designs – </b>Traditional and modern styles

                        </p>
                        <p className='mb-2' ><b>Trusted by Generations – </b>A name synonymous with quality</p>
                        <p><b>Where Kindness Meets Service – </b>Every customer is cherished</p>
                        <br/>
                        <p>If you are in Berhampore or anywhere in Murshidabad and want to experience a jewellery showroom that combines tradition, trust, and elegance, MB Dhar and Son Jewellers is the place to visit.</p>
                        <h6 ><b>Team MR. INDIAN CODER</b></h6>
                    </div>
                </div>

                <br />

            </div>


        </div>
    )
}

export default Mbdhar